import currency from 'currency.js'

import { formatCurrency } from '@/utils/currencyHelpers'
import { Icon, Popover, Text } from '@/ui'
import { Gusto_Payroll } from '../../generated_gusto_types'
import { TypographyStyles } from '@/styles'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
export const PaymentOverview = ({
  payroll: { totals },
}: {
  payroll: Gusto_Payroll
}) => {
  const {
    net_pay_debit,
    employer_taxes,
    company_debit,
    employee_taxes,
    reimbursement_debit,
  } = totals || {}

  return (
    <div className="flex flex-col md:flex-row items-start justify-center text-center gap-4 md:gap-6">
      <div className="w-full md:w-1/4">
        <div className="flex items-start justify-center gap-2">
          <Text variant={TypographyStyles.BODY_LG}>Employee Wages</Text>
          <Popover>
            <Popover.Trigger>
              <Icon icon={faInfoCircle} />
            </Popover.Trigger>
            <Popover.Content>
              <Text>
                This consists of employee wages, reimbursements, and bonuses
                paid in this payroll cycle.
              </Text>
            </Popover.Content>
          </Popover>
        </div>
        <Text
          variant={TypographyStyles.BODY_LG}
          className="text-center amount mt-1"
        >
          {formatCurrency(
            currency(net_pay_debit || 0).add(reimbursement_debit || 0)
          )}
        </Text>
      </div>

      <div className="w-full md:w-[40px] flex items-center justify-center">
        <Text variant={TypographyStyles.BODY_LG} className="math-symbol">
          +
        </Text>
      </div>

      <div className="w-full md:w-1/4">
        <div className="flex items-start justify-center gap-2">
          <Text variant={TypographyStyles.BODY_LG}>Payroll Taxes</Text>
          <Popover>
            <Popover.Trigger>
              <Icon icon={faInfoCircle} />
            </Popover.Trigger>
            <Popover.Content>
              <Text>
                This includes federal and state payroll taxes paid in this
                payroll cycle.
              </Text>
            </Popover.Content>
          </Popover>
        </div>
        <Text
          variant={TypographyStyles.BODY_LG}
          className="text-center amount mt-1"
        >
          {formatCurrency(
            currency(employer_taxes || 0).add(employee_taxes || 0)
          )}
        </Text>
      </div>

      <div className="w-full md:w-[40px] flex items-center justify-center">
        <Text variant={TypographyStyles.BODY_LG} className="math-symbol">
          =
        </Text>
      </div>

      <div className="w-full md:w-2/4">
        <div className="flex items-start justify-center gap-2">
          <Text variant={TypographyStyles.BODY_LG} className="text-green-600">
            Total Withdrawn from Bank Account
          </Text>
          <Popover>
            <Popover.Trigger>
              <Icon icon={faInfoCircle} />
            </Popover.Trigger>
            <Popover.Content>
              <Text>
                This is the amount that will be taken from your attached bank
                account for this payroll cycle.
              </Text>
            </Popover.Content>
          </Popover>
        </div>
        <Text
          variant={TypographyStyles.BODY_LG}
          className="amount mt-1 text-green-600 text-center"
        >
          <b>{formatCurrency(company_debit)}</b>
        </Text>
      </div>
    </div>
  )
}
